var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 84,
    viewBox: "0 0 204 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 84,
    rx: 8,
    fill: "#566374"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8 84C3.58173 84 0 80.4183 0 76V38.8259C0 31.7688 8.47234 28.1686 13.5527 33.0667L17.2517 36.6331C18.1099 37.4606 19.1422 38.0857 20.273 38.4629L33.2211 42.7819C35.3036 43.4765 37.5801 43.2849 39.5171 42.2518L50.9198 36.1706C54.1309 34.4581 58.0932 35.1286 60.562 37.8023L69.9601 47.9803C72.2775 50.49 75.9328 51.2514 79.0595 49.8757L87.3406 46.2322C90.5105 44.8375 94.2178 45.6408 96.5261 48.2224L106.303 59.1574C109.125 62.3127 113.916 62.7243 117.234 60.0965L126.484 52.771C128.276 51.3519 130.589 50.7671 132.84 51.1641L146.084 53.5C147.518 53.753 148.856 54.3927 149.954 55.3502L162.972 66.708C165.165 68.6218 168.225 69.193 170.962 68.1995L181.468 64.3848C183.566 63.623 185.887 63.7724 187.87 64.797L200.345 71.2419C202.59 72.4017 204 74.7173 204 77.2441C204 80.9753 200.975 84 197.244 84H8Z",
    fill: "url(#paint0_linear_1934_47)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566374"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintRequest);
export default __webpack_public_path__ + "static/media/MaintRequest.a52d0a80df39b89abab7a5f63aeffe01.svg";
export { ForwardRef as ReactComponent };